import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  CancelCrossIcon,
  ArrowLeftIcon,
  Header2,
  PersonPlusIcon,
  Fade,
  Slide,
  IconButton,
} from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";
import * as ConversationHeaders from "./ConversationTypeHeaders/index.jsx";
import { CreateTaskHeader } from "./CreateTaskHeader.js";
import { useConversationContentContext, useConversationContext } from "../../context/index.jsx";
import { useInviteOption } from "../../MenuOptions/index.jsx";
import { CREATE_TASK_MODE } from "../ConversationContent/index.jsx";

export const Header = ({ onClose, type, onBack, conversationId, onShowParticipants, ...rest }) => {
  const { screen, setScreen, mode } = useConversationContentContext();
  const { canManage = false } = useConversationContext();
  const { t } = useTranslation();

  const ConversationHeader = ConversationHeaders[type];
  const isParticipantsScreen = screen === "participants";

  const { onShowInviteDialog, inviteTemplate } = useInviteOption();

  const handleClick = useCallback(() => {
    typeof onClose === "function" && onClose();
  }, [onClose]);

  const handleOnBack = useCallback(() => {
    if (isParticipantsScreen) {
      setScreen("conversation");
    } else {
      typeof onBack === "function" && onBack();
    }
  }, [onBack, isParticipantsScreen, setScreen]);

  return (
    <div className="hub-header tw-relative tw-flex tw-items-center tw-p-2 tw-overflow-hidden">
      {mode === CREATE_TASK_MODE ? <CreateTaskHeader /> : null}

      {mode === "" ? (
        <>
          {onBack ? (
            <IconButton
              variant="text gray"
              onClick={handleOnBack}
              className="tw-mr-1 tw-shrink-0"
            >
              <ArrowLeftIcon />
            </IconButton>
          ) : null}
          <Slide
            in={!isParticipantsScreen}
            timeout={200}
            initialDirection="left"
          >
            <Fade
              in={!isParticipantsScreen}
              timeout={200}
              onExited={onShowParticipants}
            >
              <div
                className={classnames("hub-header-title tw-flex tw-items-center tw-min-w-0", {
                  "participants-active": isParticipantsScreen,
                })}
              >
                {ConversationHeader ? (
                  <ConversationHeader
                    conversationId={conversationId}
                    {...rest}
                  />
                ) : null}
              </div>
            </Fade>
          </Slide>
          <Slide
            in={isParticipantsScreen}
            timeout={200}
            initialDirection="right"
          >
            <Fade
              in={isParticipantsScreen}
              timeout={200}
            >
              <div
                className={classnames("hub-header-participants-title tw-truncate tw-ml-1 tw-min-w-0", {
                  "participants-active": isParticipantsScreen,
                })}
              >
                <Header2
                  weight="bold"
                  color="primary"
                  className="tw-truncate tw-min-w-0"
                >
                  {t("Participants")}
                </Header2>
              </div>
            </Fade>
          </Slide>
          <div className="hub-header-btn tw-flex tw-items-center">
            {isParticipantsScreen && type === "GroupConversation" && canManage ? (
              <IconButton
                variant="text gray"
                onClick={onShowInviteDialog}
              >
                <PersonPlusIcon />
              </IconButton>
            ) : null}
            {onClose ? (
              <IconButton
                variant="text gray"
                onClick={handleClick}
                className="tw-ml-1"
              >
                <CancelCrossIcon />
              </IconButton>
            ) : null}
          </div>
        </>
      ) : null}
      {inviteTemplate}
    </div>
  );
};

Header.propTypes = {
  type: PropTypes.string,
  conversationId: PropTypes.number,
  onClose: PropTypes.func,
  onBack: PropTypes.func,
  onShowParticipants: PropTypes.func,
};
